var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-none"},_vm._l((_vm.transformedReference),function(referenceEntry){return _c('input',{key:referenceEntry.name,attrs:{"type":"hidden","name":referenceEntry.name},domProps:{"value":referenceEntry.value}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }